















































import {Component, Prop, Vue} from "vue-property-decorator";
    import DeleteButton from "@/components/datatable/DeleteButton.vue";
    import EForm from "@/components/datatable/EForm.vue";
    import Number from "@/components/inputs/Number.vue";
    import TextField from "@/components/inputs/TextField.vue";
    import Id from "@/components/inputs/Id.vue";
    import Select35 from "@/components/inputs/Select35.vue";
    import LetEditable from "@/components/LetEditable.vue";
import tr from "vuetify/src/locale/tr";

    class VariantOptionInfo{
        product_option_info_id!:number;
        product_id!:number;
        product_option_id!:number;
        content!:number;
        user_count!:number;
        file_count!:number;
        disk_size!:number;
    }
    @Component({
        components: {
            LetEditable,
            Select35,
            DeleteButton,EForm,Number,TextField,Id
        }
    })
    export default class ProductVariantOptionInfo extends  Vue{
      @Prop({required:true}) product_id!:number;
      @Prop({required:true}) product_option_id!:number;
      items : VariantOptionInfo[] | null = null;
        dialog = false;
        title:string = "";
        search: string = "";
        baseAction:string = "productVariantOptionInfo";
        action:string = this.baseAction;
        data : VariantOptionInfo = new VariantOptionInfo();
        headers = [
            {text: "İçerik", value: "content"},
            {text: "Dosya Sayısı", value: "file_count"},
            {text: "Kullanıcı Sayısı", value: "user_count"},
            {text: "Disk Boyutu", value: "disk_size"},
            {text: "İşlemler", value: "actions"}
        ];
        async deleteGroup(product_group_list_id : number){
            await this.$http.delete("productGroupList/"+product_group_list_id);
        }
        edit(item:VariantOptionInfo){
            this.title = "Düzenle";
            this.data = item;
            this.action = this.baseAction + "/" + item.product_option_info_id;
            this.dialog = true;
        }
        add(){
            this.title = "Varyasyon İçerik Ekle";
            this.action = this.baseAction;
            this.data = new VariantOptionInfo();
            this.data.product_id = this.product_id;
            this.data.product_option_id = this.product_option_id;
            this.dialog = true;
        }
        async get(){
          if(this.product_option_id){
            this.dialog = false;
            let response = await this.$http.get(this.baseAction + "?product_id=" + this.product_id + "&product_option_id=" + this.product_option_id);
            //todo
            this.items = response.data;
          }
        }

        created(){
            this.get();
        }
    };
